// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfHour as fn } from "../startOfHour.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfHour = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfHour;
